module.exports = __webpack_public_path__ + "img/mistakesText2.d407598b.png";